import { Waveform, ArrowLeft, Phone, ShieldCheck } from "@phosphor-icons/react";
import { useNavigate, Link } from "react-router-dom";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: "#0A0A0C" }}>
      <header className="relative z-10 backdrop-blur-xl bg-[#0A0A0C]/70 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12 py-5">
          <div className="flex items-center gap-4">
            <button onClick={() => navigate("/")} className="text-white/60 hover:text-white transition-colors" data-testid="privacy-back-btn">
              <ArrowLeft size={24} />
            </button>
            <div className="flex items-center gap-3">
              <Waveform size={28} weight="bold" style={{ color: "#F59E0B" }} />
              <span className="text-xl font-light tracking-tight text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>Daremusics</span>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-8 lg:px-12 py-12">
        <div className="flex items-center gap-3 mb-8">
          <ShieldCheck size={32} weight="bold" style={{ color: "#F59E0B" }} />
          <h1 className="text-4xl sm:text-5xl tracking-tight font-light text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Privacy Policy
          </h1>
        </div>

        <div className="bg-[#141417] border border-white/5 rounded-2xl p-6 md:p-8 space-y-6" style={{ fontFamily: "'Manrope', sans-serif" }}>
          <p className="text-sm" style={{ color: "#A1A1AA" }}>Last updated: April 2026</p>

          <section>
            <h3 className="text-lg text-white font-medium mb-3">1. Information We Collect</h3>
            <p className="text-base leading-relaxed" style={{ color: "#A1A1AA" }}>
              When you create an account on Daremusics, we collect your name, email address, and password (stored in encrypted form). When you use our services, we collect your song concepts, generated lyrics, music prompts, and song generation history. Payment information is processed securely by Razorpay and we do not store your card details.
            </p>
          </section>

          <section>
            <h3 className="text-lg text-white font-medium mb-3">2. How We Use Your Information</h3>
            <ul className="space-y-2" style={{ color: "#A1A1AA" }}>
              <li className="flex items-start gap-2 text-base leading-relaxed">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#F59E0B] shrink-0" />
                To provide and maintain our AI song generation services
              </li>
              <li className="flex items-start gap-2 text-base leading-relaxed">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#F59E0B] shrink-0" />
                To manage your account and subscription
              </li>
              <li className="flex items-start gap-2 text-base leading-relaxed">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#F59E0B] shrink-0" />
                To process your payments through Razorpay
              </li>
              <li className="flex items-start gap-2 text-base leading-relaxed">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#F59E0B] shrink-0" />
                To communicate with you regarding your account or support requests
              </li>
            </ul>
          </section>

          <section>
            <h3 className="text-lg text-white font-medium mb-3">3. Data Storage & Security</h3>
            <p className="text-base leading-relaxed" style={{ color: "#A1A1AA" }}>
              Your data is stored securely on encrypted servers. Passwords are hashed using bcrypt. We implement industry-standard security measures to protect your personal information from unauthorized access.
            </p>
          </section>

          <section>
            <h3 className="text-lg text-white font-medium mb-3">4. Third-Party Services</h3>
            <p className="text-base leading-relaxed" style={{ color: "#A1A1AA" }}>
              We use third-party services for AI-powered content generation and payment processing (Razorpay). These services have their own privacy policies and we encourage you to review them.
            </p>
          </section>

          <section>
            <h3 className="text-lg text-white font-medium mb-3">5. Your Rights</h3>
            <p className="text-base leading-relaxed" style={{ color: "#A1A1AA" }}>
              You have the right to access, update, or delete your personal information. You can request account deletion by contacting our support team. Upon deletion, all your data including song history will be permanently removed.
            </p>
          </section>

          <section>
            <h3 className="text-lg text-white font-medium mb-3">6. Cookies</h3>
            <p className="text-base leading-relaxed" style={{ color: "#A1A1AA" }}>
              We use essential cookies for authentication purposes to keep you logged in. These are httpOnly cookies and are not used for tracking or advertising.
            </p>
          </section>

          <section>
            <h3 className="text-lg text-white font-medium mb-3">7. Changes to This Policy</h3>
            <p className="text-base leading-relaxed" style={{ color: "#A1A1AA" }}>
              We may update this Privacy Policy from time to time. We will notify you of any changes by updating the "Last updated" date on this page.
            </p>
          </section>

          <div className="border-t border-white/10 pt-6">
            <div className="flex items-center gap-2 mb-3">
              <Phone size={20} weight="bold" style={{ color: "#F59E0B" }} />
              <span className="text-xs uppercase tracking-[0.2em] font-bold" style={{ color: "#F59E0B" }}>Contact Us</span>
            </div>
            <p className="text-sm mb-2" style={{ color: "#A1A1AA" }}>Daremusics</p>
            <div className="flex gap-6">
              <a href="tel:9493926054" className="text-white hover:text-[#F59E0B] transition-colors">9493926054</a>
              <a href="tel:9493924588" className="text-white hover:text-[#F59E0B] transition-colors">9493924588</a>
            </div>
            <div className="mt-3">
              <Link to="/terms" className="text-sm hover:text-white transition-colors" style={{ color: "#F59E0B" }}>Terms & Conditions</Link>
              <span className="text-white/20 mx-3">|</span>
              <Link to="/refund-policy" className="text-sm hover:text-white transition-colors" style={{ color: "#F59E0B" }}>Refund Policy</Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicyPage;
